import DescriptionModal from '@/modals/DescriptionModal.vue';
import { openModal } from '@/modals/helpers/api';
export function openDescriptionModal(content, options) {
    const name = options?.type ? `${options.type}-description-modal` : 'description-modal';
    openModal({
        name,
        component: DescriptionModal,
        title: options?.title ?? '',
        mobile: 'full-screen',
        props: { content },
        describedBy: 'description-modal-content',
    });
}
